// src/pages/WatchDemo.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import './WatchDemo.css';

const WatchDemo = () => {
  const navigate = useNavigate();

  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        navigate(-1);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);

  // Prevent body scroll
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <motion.div
      className="video-page-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      onClick={() => navigate(-1)}
    >
      <motion.div
        className="video-page-container"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="video-page-header">
          <h2>🎬 ZustandTech Demo</h2>
          <button
            className="video-close-btn"
            onClick={() => navigate(-1)}
            title="Close"
          >
            <FaTimes />
          </button>
        </div>

        {/* Video Player */}
        <div className="video-player-wrapper">
          <video
            className="video-player"
            controls
            autoPlay
            playsInline
            controlsList="nodownload"
          >
            <source src="/zust.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Info */}
        <div className="video-page-info">
          <p>
            Watch how ZustandTech builds scalable web & mobile solutions for businesses worldwide.
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default WatchDemo;